<template>
  <div class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <UiKitInput
        v-model="form.legal.INN"
        label="ИНН"
        placeholder="Введите ИНН"
      />
      <UiKitInput
        v-model="form.legal.OGRN"
        label="ОГРН"
        placeholder="Введите ОГРН"
      />
      <UiKitInput
        v-model="form.legal.legal_address"
        label="Юридический адрес"
        placeholder="Введите юридический адрес"
        class="md:col-span-2"
      />
      <UiKitInput
        v-model="form.legal.individual_entrepreneur"
        label="Индивидуальный предприниматель"
        placeholder="ФИО ИП"
        class="md:col-span-2"
      />
    </div>

    <div class="flex gap-3 pt-4 border-t border-hui-divider">
      <UiKitButton type="button" color="primary" :loading="loading" :disabled="loading" @click="saveSettings">
        Сохранить
      </UiKitButton>
      <UiKitButton type="button" color="default" variant="flat" @click="closeModal">
        Отмена
      </UiKitButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import consola from 'consola'
import { useKitToast } from '@shared/ui/kit'
import { APIAdminInstitution } from '~/fsd-pages/admin/api'

const emit = defineEmits<{
  close: []
  'update:size': [size: string]
}>()

const { toast: kitToast } = useKitToast()
const toast = {
  add: (o: { title?: string; description?: string; color?: string; timeout?: number }) =>
    kitToast({ color: o.color === 'green' ? 'success' : o.color === 'red' ? 'danger' : o.color === 'orange' ? 'warning' : 'default', title: o.title, description: o.description, timeout: o.timeout }),
}

const loading = ref(false)

const form = ref({
  legal: {
    INN: '',
    OGRN: '',
    legal_address: '',
    individual_entrepreneur: '',
  },
})

onMounted(() => {
  emit('update:size', 'l')
  loadSettings()
})

const loadSettings = async () => {
  try {
    loading.value = true
    const legalSettings = await APIAdminInstitution.getLegalSettings()
    form.value = {
      legal: {
        INN: legalSettings.legal.INN || '',
        OGRN: legalSettings.legal.OGRN || '',
        legal_address: legalSettings.legal.legal_address || '',
        individual_entrepreneur: legalSettings.legal.individual_entrepreneur || '',
      },
    }
  } catch (error) {
    consola.error('Ошибка загрузки настроек:', error)
    toast.add({ title: 'Ошибка', description: 'Ошибка загрузки настроек', color: 'red' })
  } finally {
    loading.value = false
  }
}

const saveSettings = async () => {
  try {
    loading.value = true
    await APIAdminInstitution.updateLegalSettings({
      INN: form.value.legal.INN,
      OGRN: form.value.legal.OGRN,
      legal_address: form.value.legal.legal_address,
      individual_entrepreneur: form.value.legal.individual_entrepreneur,
    })
    toast.add({ title: 'Сохранено', description: 'Настройки успешно сохранены', color: 'green' })
    setTimeout(() => {
      closeModal()
    }, 1500)
  } catch (error) {
    consola.error('Ошибка сохранения настроек:', error)
    toast.add({ title: 'Ошибка', description: 'Ошибка сохранения настроек', color: 'red' })
  } finally {
    loading.value = false
  }
}

const closeModal = () => {
  emit('close')
}
</script>
